import { createTheme, responsiveFontSizes, adaptV4Theme } from "@mui/material";

// colors
/*const primary = "#b3294e";
const secondary = "#4829B2";*/
const primary = "#fcdedc"; /* rose poudré */
const primaryDarker = "#FAC8C5"; /*white*/
const primaryLighter = "#FEF4F3"; /*white*/

const secondary = "#b5a79a"; /*brown/silk*/
const secondaryDarker = "#9F8D7D"; /*brown/silk*/
const secondaryLighter = "#D5CDC6"; /*brown/silk*/

const tertiary = "#fee37d"; /*yellow/salomie*/
const tertiaryDarker = "#FED84A"; /*yellow/salomie*/
const tertiaryLighter = "#FFF3C9"; /*yellow/salomie*/

const black = "#343a40";
const darkBlack = "rgb(36, 40, 44)";
const background = "#f5f5f5";
const darkBackground = "#141414f5";
const warningLight = "rgba(253, 200, 69, .3)";
const warningMain = "rgba(253, 200, 69, .5)";
const warningDark = "rgba(253, 200, 69, .7)";

// border
const borderWidth = 2;
const borderColor = "rgba(0, 0, 0, 0.13)";

// breakpoints
const xl = 1920;
const lg = 1280;
const md = 960;
const sm = 600;
const xs = 0;

// spacing
const spacing = 8;

const theme = createTheme(
  adaptV4Theme({
    palette: {
      primary: {
        main: primary,
        darker: primaryDarker,
        lighter: primaryLighter,
      },
      secondary: {
        main: secondary,
        darker: secondaryDarker,
        lighter: secondaryLighter,
      },
      tertiary: {
        main: tertiary,
        darker: tertiaryDarker,
        lighter: tertiaryLighter,
      },
      common: {
        black,
        darkBlack,
      },
      warning: {
        light: warningLight,
        main: warningMain,
        dark: warningDark,
      },
      // Used to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
      background: {
        default: background,
        dark: darkBackground,
      },
      spacing,
    },
    breakpoints: {
      // Define custom breakpoint values.
      // These will apply to Material-UI components that use responsive
      // breakpoints, such as `Grid` and `Hidden`. You can also use the
      // theme breakpoint functions `up`, `down`, and `between` to create
      // media queries for these breakpoints
      values: {
        xl,
        lg,
        md,
        sm,
        xs,
      },
    },
    border: {
      borderColor: borderColor,
      borderWidth: borderWidth,
    },
    overrides: {
      MuiExpansionPanel: {
        root: {
          position: "static",
        },
      },
      MuiTableCell: {
        root: {
          paddingLeft: spacing * 2,
          paddingRight: spacing * 2,
          borderBottom: `${borderWidth}px solid ${borderColor}`,
          [`@media (max-width:  ${sm}px)`]: {
            paddingLeft: spacing,
            paddingRight: spacing,
          },
        },
      },
      MuiDivider: {
        root: {
          backgroundColor: borderColor,
          height: borderWidth,
        },
      },
      MuiPrivateNotchedOutline: {
        root: {
          borderWidth: borderWidth,
        },
      },
      MuiListItem: {
        divider: {
          borderBottom: `${borderWidth}px solid ${borderColor}`,
        },
      },
      MuiDialog: {
        paper: {
          width: "100%",
          maxWidth: 430,
          marginLeft: spacing,
          marginRight: spacing,
        },
      },
      MuiTooltip: {
        tooltip: {
          backgroundColor: darkBlack,
        },
      },
      MuiExpansionPanelDetails: {
        root: {
          [`@media (max-width:  ${sm}px)`]: {
            paddingLeft: spacing,
            paddingRight: spacing,
          },
        },
      },
    },
    typography: {
      useNextVariants: true,
      allVariants: {
        fontFamily: "Poppins,PT Serif",
        textTransform: "none",
        fontSize: "16px",
        fontWeight: " normal",
        letterSpacing: "0.05rem",
      },
      handWritingFont: {
        fontFamily: "Allura,Dancing Script",
      },
      titleFont: {
        fontFamily: "Prata",
      },
      testText: {
        fontFamily: "Raleway",
      },
      roundedFont: {
        fontFamily: "Tsukimi Rounded",
      },
    },
    navBarHeight: "9rem",
    bannerTheme: {
      pageBanner: {
        overflow: "hidden",
        maxHeight: "50vh",
        height: "27rem",
        position: "relative",
      },
      pageBannerImgItem: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        position: "absolute",
        filter: "brightness(0.7)",
      },
      pageTitle: {
        marginTop: "9rem",
        fontSize: "2.5rem",
        position: "absolute",
        width: "100%",
        bottom: "2rem",
        color: "white",
        textWrap: "nowrap",
        /*fontWeight: "bold",*/
        fontFamily: "Prata,Raleway,Georgia,Times New Roman,serif",
        letterSpacing: "0.2rem",
        "&:after": {
          bottom: "-2rem",
          right: "-0.5rem",
          width: "5%",
          height: "2px",
          content: "''",
          position: "relative",
          background: tertiary,
          display: "inline-flex",
        },
        "&:before": {
          bottom: "-2rem",
          left: "-0.5rem",
          width: "5%",
          height: "2px",
          content: "''",
          position: "relative",
          background: tertiary,
          display: "inline-flex",
        },
      },
    },
    doubleTitleTheme: {
      doubleTitleMain: {
        fontSize: "2rem",
        textWrap: "nowrap",
      },
      doubleTitleSub: {
        fontFamily: "Allura,Dancing Script",
        color: tertiaryDarker,
        position: "absolute",
        fontSize: "1.5rem",
        zIndex: "-1",
        paddingLeft: "2rem",
        top: "-1rem",
        textWrap: "nowrap",
      },
    },
  })
);

export default responsiveFontSizes(theme);
